export const chartColors = [
  '#7cb5ec',
  '#434348',
  '#f7a35c',
  '#8085e9',
  '#e4d354',
  '#2b908f',
  '#91e8e1',
  '#f15c80',
  '#8d4654'
];

export const getColorByIndex = (index) => {
  return chartColors[index % chartColors.length];
};
